import React from "react";
import {ErrorBlock} from "~/components/ErrorBlocks/ErrorBlock";
import {Button, SvgIcon} from "@mui/material";
import {useHistory} from "react-router-dom";


export type ServiceUnavailableProps = {
    text?: string
}


export const ServiceUnavailable = ({text}: ServiceUnavailableProps) => {
    const history = useHistory();

    const handleButtonClick = () => {
        history.push("/");
    }

    return (
        <ErrorBlock
            title="Сервис недоступен"
            icon={(
                <SvgIcon width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" clipRule="evenodd" d="M20.8194 3.30278H17.6138C17.6137 3.30278 17.6137 3.30278 17.6137 3.30278C17.0027 3.30278 16.4802 3.71967 16.3435 4.31569C16.3421 4.32152 16.3407 4.32731 16.3392 4.33307L14.4507 12.6006H23.9823L22.0936 4.33223C22.0922 4.32675 22.0908 4.32124 22.0896 4.31569C21.9534 3.71902 21.431 3.30278 20.8194 3.30278ZM20.8194 2H17.6138C17.6137 2 17.6137 2 17.6137 2C16.4043 2 15.3695 2.8145 15.0831 3.98646C15.0794 3.99909 15.076 4.01192 15.0731 4.02493L13.0027 13.0884C12.9996 13.1004 12.9968 13.1125 12.9944 13.1247L10.7592 22.9098C10.7541 22.9281 10.7499 22.9467 10.7464 22.9655L8.39334 33.2666H5.65139C5.29182 33.2666 5 33.5584 5 33.918V36.5235C5 36.8831 5.29182 37.1749 5.65139 37.1749H32.7818C33.1413 37.1749 33.4331 36.8831 33.4331 36.5235V33.918C33.4331 33.5584 33.1413 33.2666 32.7818 33.2666H30.0403L25.4402 13.1306C25.4371 13.1144 25.4334 13.0984 25.4292 13.0826L23.3599 4.0249C23.3584 4.01826 23.3568 4.01168 23.3551 4.00514C23.0751 2.8238 22.0358 2 20.8194 2ZM26.5256 23.7344L28.7031 33.2666H9.72991L11.9074 23.7344H26.5256ZM12.205 22.4316H26.2281L25.9305 21.129H12.5025L12.205 22.4316ZM24.8751 16.5088L25.6329 19.8262H12.8001L13.5579 16.5088H24.8751ZM13.8555 15.2061H24.5775L24.2799 13.9034H14.1531L13.8555 15.2061ZM6.30278 35.8722H32.1304V34.5694H6.30278V35.8722Z" fill="#6E798C"/>
                </SvgIcon>
            )}
            button={(
                <Button onClick={handleButtonClick}>
                    Перейти на главную
                </Button>
            )}
        >
            {text || "Ведутся профилактические работы. Воспользуйтесь сервисом позже"}
        </ErrorBlock>
    );
}
